"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFeatureFlags = exports.getConsentedDeviceId = void 0;
var client_1 = require("./client");
Object.defineProperty(exports, "getConsentedDeviceId", { enumerable: true, get: function () { return client_1.getConsentedDeviceId; } });
Object.defineProperty(exports, "initFeatureFlags", { enumerable: true, get: function () { return client_1.initFeatureFlags; } });
